export default "__VITE_ASSET__DKSzE0Vv__"